import {Product, QueryOptionsType} from '@framework/types';
import http from '@framework/utils/http';
import {API_ENDPOINTS} from '@framework/utils/api-endpoints';
import {useQuery} from '@tanstack/react-query';

export const fetchSearchedProducts = async ({ queryKey }: any) => {
  const options = queryKey.find((item: any) => typeof item != "string");
  if (!options.text || options.text.length < 3) {
    return []
  }

  const {data} = await http.get(`${API_ENDPOINTS.PRODUCTS}?search=${options.text}&limit=${options.limit}`);

  return data.data as Product[];
};
export const useSearchQuery = (options: QueryOptionsType) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.PRODUCTS, 'search', options],
    queryFn: fetchSearchedProducts,

  });
};
